import { ChangeDetectorRef, Component, OnDestroy, OnInit, ViewChild } from "@angular/core";
import { ControllerService } from "../../shared/services/controller.service";
import { ActivatedRoute } from "@angular/router";
import { HttpService } from "../../shared/services/http.service";


@Component({
    selector: "app-reflection",
    templateUrl: "./reflection.component.html",
    styleUrls: ["./reflection.component.scss"],
    standalone: false
})
export class ReflectionComponent implements OnInit, OnDestroy{


  @ViewChild("textarea", { static: false }) textarea;

  pageObserver = null

  pages = []

  page = null

  displayedPage = 0
  displayedPageIncrement = 0
  pageCount = 0
  isIntro = false

  haveNext = false
  haveBack = false
  haveStart = false

  emailReflections = false

  answer = ''

  answers = {}


  constructor( public controller: ControllerService, private route: ActivatedRoute, private chRef: ChangeDetectorRef, private httpService: HttpService ){

  }


  async loadPage( p ){

    this.page = this.pages[p]

    this.emailReflections = this.page.properties && this.page.properties.emailReflections == 'true'

    this.isIntro = this.page.properties && this.page.properties.intro == 'true'

    this.answer = this.controller.getReflection(this.getQuestion())

    this.displayedPage = p + this.displayedPageIncrement

    this.haveBack = p > 0 && !this.emailReflections

    this.haveNext = !this.isIntro && this.answer && this.answer.length > 0

    this.haveStart =  this.isIntro && !this.emailReflections

  }

  ngOnInit(): void {

    this.pages = this.controller.getSectionComponents()

    this.pageCount = this.pages.filter( page => !(page.properties && page.properties.intro == 'true') ).length
    // we don't have an intro page, so we start the displaydPage from 1
    if( this.pageCount == this.pages.length ){
      this.displayedPageIncrement = 1
    }

    this.pageObserver = this.route.queryParams.subscribe( (params) => {

      this.loadPage( this.controller.getPage() )
    })

    this.loadPage( this.controller.getPage() )

  }

  getQuestion() {
    return this.page.elements.find( ({type}) => type == 'header').value
  }

  async onNext( ){

    if( this.isIntro ){
      this.controller.next()
      return;
    }

    const text = this.textarea.nativeElement.value

    if( text.length == 0 ){
      return
    }

    const question = this.getQuestion()

    this.controller.setReflection(question, text)

    this.controller.next()
  }

  onBack(){
    this.controller.back()
  }

  ngOnDestroy(): void {

    this.pageObserver.unsubscribe()

  }

  onType( $event ){

    this.answer = $event.target.value
    this.haveNext = this.answer.length > 1
    this.chRef.detectChanges();
  }

  getButtonsClassObject(){

    return {
      buttons: true,
      'only-next': !this.isIntro && !this.haveBack,
      'only-start': this.haveStart || this.emailReflections,
      'only-back': !this.haveNext && !this.haveStart && !this.emailReflections
    }

  }

}
